import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CiiComponent } from './cii.component';

const routes: Routes = [
  {
    path: '',
    component: CiiComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CiiRoutingModule {}
